//--------------------------------------------------------------------------
// <copyright file="PairingInProgressDialog.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import FluentPrimaryButton from './FluentPrimaryButton';
import MicrosoftLogo from './MicrosoftLogo';
import BackButton from './BackButton';
import PairingStates from "../models/PairingStatesEnum";

/// <summary>
/// Helper methods and display components related to Pairing In Progress dialog.
/// </summary>
const PairingInProgressDialog = ({username, setPairingState, setPairingCode, pairingCode,logout}) => { 
  const pairAnotherDevice = () => {
    setPairingCode('');
    setPairingState(PairingStates.PairingCodeNotEntered);
  }

  return (
    <div className="Dialog">
      <MicrosoftLogo/>
      <BackButton onClickFunction={logout}/>
      <h1 role="alert" className="Dialog-header-inprogress">Authorization succeeded.<br/> Your device should update in few minutes.</h1>
      <p data-testid="message" className="Dialog-paragraph-inprogress">You may close this window now.</p>
      <p data-testid="username" className="Dialog-username">{username}</p>
      <a className="Dialog-feedback-success" rel="noreferrer noopener" target="_blank" href="https://feedbackportal.microsoft.com/feedback/">Give feedback</a>
      <FluentPrimaryButton text = 'Pair another' cssClassName = 'Dialog-button-pairanother' setPairingState = {setPairingState} pairCode = {pairingCode} onClickFunction = {pairAnotherDevice}/>
    </div>
  )
}

export default PairingInProgressDialog
